export default "__VITE_ASSET__BVmPjYCu__"